import { useLang } from 'hooks/lang';

import { Button, Column, Row } from 'components/Blocks';
import { UserPlusIcon, WarningIcon } from 'components/Icons';

import { ActiveProjectsByUser } from 'pages/PendingActions/ProjectAssign';
import { useProjectOption } from '../ProjectOptions';

export function AssignProject() {
  const { t } = useLang();

  const changeUser = useProjectOption('CHANGE_OWNER');

  if (!changeUser.isEnabled) return null;

  return (
    <Row className="small_tablet:flex-col" alignItems="flex-start">
      <Column className="flex-1 rounded-lg border border-warning p-6">
        <Row gap="2.5">
          <WarningIcon color="warning" />

          <span className="font-semibold">{t('project-not-assigned')}</span>
        </Row>

        <span className="text-sm">{t('ensure-you-now-the-best-owner')}</span>

        <Button onClick={changeUser.action} variant="outlined" color="warning">
          <UserPlusIcon />
          {t('assign-project')}
        </Button>
      </Column>

      <div className="ml-auto min-w-96">
        <ActiveProjectsByUser />
      </div>
    </Row>
  );
}
